import { createAction } from '@reduxjs/toolkit'
import { ReportStakingType } from './type'

export const updateReportStaking = createAction<ReportStakingType>('staking/updateReportStaking')
